import React from "react";

export default function CalendarSkeleton() {
  return (
    <div className="calendar">
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }


  .calendar {
    width: 100%;
    max-width: 1040px;
    background: #fff;
    border: 1px solid #e8e4fb;
    border-radius: 14px;
    overflow: hidden;
  }

  /* ── SHIMMER ── */
  @keyframes shimmer {
    0%   { background-position: -800px 0; }
    100% { background-position:  800px 0; }
  }

  .sk {
    background: linear-gradient(
      90deg,
      #e8e3fb 25%,
      #d5cef5 50%,
      #e8e3fb 75%
    );
    background-size: 800px 100%;
    animation: shimmer 1.5s infinite linear;
    border-radius: 5px;
  }

  /* ── Day headers row ── */
  .header-row {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    border-bottom: 1px solid #ece8fb;
  }

  .header-cell {
    padding: 14px 12px;
    display: flex;
    justify-content: center;
    border-right: 1px solid #ece8fb;
  }

  .header-cell:last-child { border-right: none; }

  .sk-day-label { height: 13px; width: 28px; border-radius: 4px; }

  /* ── Calendar grid ── */
  .grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(6, 100px);
  }

  .cell {
    border-right: 1px solid #ece8fb;
    border-bottom: 1px solid #ece8fb;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .cell:nth-child(7n) { border-right: none; }
  .cell:nth-last-child(-n+7) { border-bottom: none; }

  /* Date number */
  .sk-date { height: 13px; width: 18px; border-radius: 4px; }

  /* Icon row inside cell */
  .sk-icons {
    display: flex;
    gap: 5px;
    margin-top: 2px;
  }

  .sk-ic {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* "X posts" label */
  .sk-posts { height: 10px; width: 44px; border-radius: 4px; }

  /* Faded cells (outside current month) */
  .cell.faded .sk { opacity: 0.35; }

  /* Highlighted cell (today-like) */
  .cell.active {
    background: #f0edfb;
    border: 1.5px solid #c4b5fd;
  }`}</style>
      {/* Day headers */}
      <div className="header-row">
        {[...Array(7)].map((_, i) => (
          <div key={i} className="header-cell">
            <div className="sk sk-day-label"></div>
          </div>
        ))}
      </div>

      {/* Calendar cells */}
      <div className="grid">
        {/* Row 1 */}
        {[...Array(7)].map((_, i) => (
          <div key={`r1-${i}`} className="cell">
            <div className="sk sk-date"></div>
          </div>
        ))}

        {/* Row 2 */}
        {[...Array(7)].map((_, i) => {
          if (i === 3) {
            // Wednesday 11 — active with icons
            return (
              <div key={`r2-${i}`} className="cell active">
                <div className="sk sk-date" style={{ width: "20px" }}></div>
                <div className="sk-icons">
                  {[...Array(4)].map((_, j) => (
                    <div key={j} className="sk sk-ic"></div>
                  ))}
                </div>
                <div className="sk sk-posts"></div>
              </div>
            );
          }
          return (
            <div key={`r2-${i}`} className="cell">
              <div className="sk sk-date"></div>
            </div>
          );
        })}

        {/* Row 3 */}
        {[...Array(7)].map((_, i) => {
          if (i === 4) {
            // Thu 19 — 1 icon
            return (
              <div key={`r3-${i}`} className="cell">
                <div className="sk sk-date"></div>
                <div className="sk-icons">
                  <div className="sk sk-ic"></div>
                </div>
                <div className="sk sk-posts" style={{ width: "36px" }}></div>
              </div>
            );
          }
          return (
            <div key={`r3-${i}`} className="cell">
              <div className="sk sk-date"></div>
            </div>
          );
        })}

        {/* Row 4 */}
        {[...Array(7)].map((_, i) => (
          <div key={`r4-${i}`} className="cell">
            <div className="sk sk-date"></div>
          </div>
        ))}

        {/* Row 5 */}
        {[...Array(7)].map((_, i) => {
          const faded = i >= 3;
          return (
            <div key={`r5-${i}`} className={`cell ${faded ? "faded" : ""}`}>
              <div className="sk sk-date"></div>
            </div>
          );
        })}

        {/* Row 6 */}
        {[...Array(7)].map((_, i) => (
          <div key={`r6-${i}`} className="cell faded">
            <div className="sk sk-date"></div>
          </div>
        ))}
      </div>
    </div>
  );
}
